import React from 'react';
import {
	ColorPicker,
	FormGroup,
	Input,
	FormControl,
	Dropdown,
	CustomText,
	Icon,
    ButtonSelect,
} from 'components';

import styles from 'styles/cart_screen.module.scss';


const ScarcitySettings = ({shopContext, }) => {

	const { state, setItem } = shopContext;
	const { scary } = state.settings

    const handleCheck = (event, name) => {
		setItem( `settings.scary.${name}`, event.target.checked);
	}

	const handleRadio = (value, name) => {
		setItem( `settings.scary.${name}`, value);
	}

    return (
      <FormGroup
        label="Scarcity Timer"
        info="Create a sense of urgency for your customers to checkout using a scarcity timer."
        fullWidth
      >
        <FormControl
          label="Timer Setup"
          isSingleCol="false"
          withSwitch={[shopContext, "settings.scary.isActive"]}
          marginBottom=""
        >
          <div
            className="row four-columns"
            style={{ gridTemplateColumns: "repeat(4, 1fr)" }}
          >
            <div className={styles.checkboxControl}>
              <input
                type="checkbox"
                id="daysCheck"
                value={"days"}
                checked={scary.isDaysActive}
                onChange={(e) => handleCheck(e, "isDaysActive")}
              />
              <label htmlFor="daysCheck" className={styles.checkbox}>
                <Icon icon="check" size="xs" />
              </label>
              <p>Days</p>
            </div>
            <div className={styles.checkboxControl}>
              <input
                type="checkbox"
                id="hoursCheck"
                value={"hours"}
                checked={scary.isHoursActive}
                onChange={(e) => handleCheck(e, "isHoursActive")}
              />
              <label htmlFor="hoursCheck" className={styles.checkbox}>
                <Icon icon="check" size="xs" />
              </label>
              <p>Hours</p>
            </div>
            <div className={styles.checkboxControl}>
              <input
                type="checkbox"
                id="minutesCheck"
                value={"minutes"}
                checked={scary.isMinutesActive}
                onChange={(e) => handleCheck(e, "isMinutesActive")}
              />
              <label htmlFor="minutesCheck" className={styles.checkbox}>
                <Icon icon="check" size="xs" />
              </label>
              <p>Minutes</p>
            </div>
            <div className={styles.checkboxControl}>
              <input
                type="checkbox"
                id="secondsCheck"
                value={"seconds"}
                checked={scary.isSecondsActive}
                onChange={(e) => handleCheck(e, "isSecondsActive")}
              />
              <label htmlFor="secondsCheck" className={styles.checkbox}>
                <Icon icon="check" size="xs" />
              </label>
              <p>Seconds</p>
            </div>
          </div>
        </FormControl>
        <FormControl isSingleCol="false" className="flex">
          <div
            className="row four-columns"
            style={{ gridTemplateColumns: "repeat(4, 1fr)" }}
          >
            <Input
              type="number"
              min={0}
              BindToContext={[shopContext, "settings.scary.days"]}
            />
            <Input
              type="number"
              max={23}
              min={0}
              BindToContext={[shopContext, "settings.scary.hours"]}
            />
            <Input
              type="number"
              max={59}
              min={0}
              BindToContext={[shopContext, "settings.scary.minutes"]}
            />
            <Input
              type="number"
              max={59}
              min={0}
              BindToContext={[shopContext, "settings.scary.seconds"]}
            />
          </div>
        </FormControl>

        <CustomText
          context={shopContext}
          label="Customize"
          path="settings.scary.text"
          hasColor={true}
        />
        <FormControl label="Alignement">
          <Dropdown
            options={[
              { value: "left", label: "Left" },
              { value: "center", label: "Center" },
              { value: "right", label: "Right" },
            ]}
            first
            BindToContext={[shopContext, "settings.scary.textAlignement"]}
          />
        </FormControl>

        <FormControl label="Timer style">
          <ButtonSelect
            options={[
              {
                value: "rounded",
                label: "Rounded",
              },
              {
                value: "full",
                label: "Full width",
              },
            ]}
            showSeparator={true}
            BindToContext={[shopContext, "settings.scary.style"]}
          />
        </FormControl>
        <FormControl>
          <ColorPicker
            text="Background"
            BindToContext={[shopContext, "settings.scary.background"]}
          />
          <ColorPicker
            text="Border"
            BindToContext={[shopContext, "settings.scary.border"]}
          />
        </FormControl>
        <FormControl label="When timeout I want to:" isSingleCol="false">
          <div className={styles.radioDiv}>
            <input
              type="radio"
              id="timerhide"
              value={"hide"}
              checked={scary.endAction === "hide"}
              onChange={(e) => handleRadio("hide", "endAction")}
            />
            <label onClick={() => handleRadio("hide", "endAction")}>
              Hide timer
            </label>
          </div>
          <div className={styles.radioDiv}>
            <input
              type="radio"
              id="timerrestart"
              value={"restart"}
              checked={scary.endAction === "restart"}
              onChange={(e) => handleRadio("restart", "endAction")}
            />
            <label onClick={() => handleRadio("restart", "endAction")}>
              Restart Timer
            </label>
          </div>
        </FormControl>
        <FormControl label="Timer Placement" isSingleCol="false">
          <div className={styles.radioDiv}>
            <input
              type="radio"
              id="timerplacementtop"
              value={"top"}
              checked={scary.placement === "top"}
              onChange={(e) => handleRadio("top", "placement")}
            />
            <label onClick={() => handleRadio("top", "placement")}>
              Top of the cart{" "}
            </label>
          </div>
          <div className={styles.radioDiv}>
            <input
              type="radio"
              id="timerplacementbottom"
              value={"bottom"}
              checked={scary.placement === "bottom"}
              onChange={() => handleRadio("bottom", "placement")}
            />
            <label onClick={() => handleRadio("bottom", "placement")}>
              Above checkout button
            </label>
          </div>
        </FormControl>
      </FormGroup>
    );
}


export  {ScarcitySettings};